import getConfig from '../../../../util/config';

/**
 * Checks if the web gallery search query is empty.
 *
 * @param {Object} searchQuery The search query as returned from the store.
 * @returns {boolean}
 */
export const isHierarchySearchQueryEmpty = searchQuery => {
  const isNameUndefined = !searchQuery?.name;
  return isNameUndefined && !searchQuery.location;
};

export const isJoinCodeQueryEmpty = searchQuery => searchQuery.join_code === '';

export const isUserQueryEmpty = searchQuery =>
  searchQuery.account_search_query === '';

export const isProDirectoryQueryEmpty = searchQuery =>
  !searchQuery.location?.locationData?.point;

export const isSearchQueryEmpty = searchQuery => {
  return (
    isHierarchySearchQueryEmpty(searchQuery) &&
    isJoinCodeQueryEmpty(searchQuery) &&
    isUserQueryEmpty(searchQuery) &&
    isProDirectoryQueryEmpty(searchQuery)
  );
};

/**
 * Given the search query as returned from the store it maps it into HierarchySearchInput.
 *
 * @param {Object} searchQuery The search query as returned from the store.
 * @returns {HierarchySearchInput}
 */
export const mapStateToHierarchySearchQueryVariables = searchQuery => {
  const { location } = searchQuery;

  return {
    limit: searchQuery.hierarchy_limit,
    offset: searchQuery.hierarchy_offset,
    name: searchQuery.name,
    location: location && {
      distance: {
        unit: 'METERS',
        value: 25000, // 25 km search radius
      },
      id: location.id,
    },
  };
};

/**
 * Given a pro directory record, regurns the associated marcom url.
 *
 * @param {Object} proDirectoryRecord The pro directory record.
 */
export const getProDirectoryFormUrl = proDirectoryRecord => {
  const { marcomUrl } = getConfig();

  return `${marcomUrl}/pro-directory?photographer_name=${proDirectoryRecord.organization_name}&photographer_id=${proDirectoryRecord.id}`;
};
